export default __webpack_public_path__ + "static/media/fabric3.d560ded5.png";